import { AssessmentState } from "@/types/models";
import { getSignedUrlForKey } from "@/lib/evidenceAccess";

const KEY = "cyber-assess-state";

export function loadState(): AssessmentState | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as AssessmentState) : null;
  } catch {
    return null;
  }
}

export function saveState(state: AssessmentState) {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    // noop
  }
}

/**
 * ACTION 2: signing is now brokered server-side by the `evidence-access`
 * Edge Function. The browser has no direct access to the evidence bucket and
 * cannot sign an arbitrary path. Signature preserved for existing call sites;
 * the TTL argument is ignored (server clamps to 60–900s, default 300s).
 */
export async function getSignedUrl(filePath: string, _expiresInSec = 60) {
  return getSignedUrlForKey(filePath, "inline");
}

export function inferKind(mime?: string, path?: string): "image" | "pdf" | "other" {
  const lower = (mime || "").toLowerCase();
  if (lower.startsWith("image/")) return "image";
  if (lower === "application/pdf" || (path || "").toLowerCase().endsWith(".pdf")) return "pdf";
  return "other";
}
